module.exports = __webpack_public_path__ + "img/acacia-building.03277f80.jpg";